/**
 * Copyright Mántum All Rights Reserved.
 */
import { lazy } from 'react';

export const Chart = lazy(() => {
    return import('@mantum/kanela-react-chart-adapter');
});
